
import React from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';
import LoginPage from "./pages/LoginPage";
import OtpVerificationPage from "./pages/OtpVeryfication/OtpVeryfication";
import PoTrackingList from "./pages/CompanyUser/PoTrackingList/PoTrackingList";
import CompanyListPage from './pages/AmtcUser/CompanyList/CompanyList';
import Layout from './components/Layout';
import MissingPage from './pages/MissingPage';
import { useAuthContext } from './context/AuthContext';
import LoadingScreen from './components/LoadingScreen';
import HomePage from './pages/HomePage/HomePage';
import RequireAuth from './components/RequireAuth';
import cs from './utils/Constants';
import AddPotPage from './pages/AmtcUser/AddPotPage';
import TestPage from './pages/TestPage';
import EditPotPage from './pages/AmtcUser/EditPotPage';
import EditPotInvPage from './pages/AmtcUser/EditPotInvPage';
const theme = createTheme({
  palette: {
    navbar: {
      navbar: "rgba(162, 214, 249, 1)",
    },
    primary: {
      button: "rgba(255, 207, 48, 1)",
      main: "rgba(162, 214, 249, 1)",
      sub: "rgba(236, 246, 219, 0.7)",
      btn: "rgb(73, 177, 247, 1)",
    },
    secondary: {
      main: "rgba(0, 0, 0, 0.3)",/*light grey*/
      sub: " rgba(0, 0, 0, 0.5)",/*Dark Grey*/
    },
    action: {
      hover: "rgba(162, 214, 249, 0.4)"
    },
    otherColors: {
      txtFieldColor: "black",
      btn: "rgb(73, 177, 247, 1)",
    },
    custom: {
      main: "rgb(73, 177, 247, 1)",
      sub: "rgba(0, 0, 0, 0.3)",
      btn: "rgb(43, 137, 252, 1)",
    },
  },
  typography: {
    fontFamily: [
      "Poppins", "Arial", "sans-serif",
    ].join(','),
    button: {
      textTransform: 'none'
    }
  },
})

function App() {
  const { loading } = useAuthContext();
  return (
    <ThemeProvider theme={theme}>
      {loading && <LoadingScreen />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/otpveryfication" element={<OtpVerificationPage />} />
        <Route element={<RequireAuth allowedRoles={[cs.requestor, cs.approver, cs.lineManager, cs.focalPoint]} />}>
          <Route path="/c" element={<Layout />}>
            <Route path="poTrackingList" element={<PoTrackingList />} />
          </Route>
        </Route>
        <Route element={<RequireAuth allowedRoles={[cs.admin, cs.ma]} />}>
          <Route path="/a" element={<Layout />}>
            <Route path="companylist" element={<CompanyListPage />} />
            <Route path="poTrackingList" element={<PoTrackingList />} />
            <Route path="addPot" element={<AddPotPage />} />
            <Route path="editPot" element={<EditPotPage />} />
          </Route>
        </Route>
        <Route element={<RequireAuth allowedRoles={[ cs.accounts]} />}>
          <Route path="/acc" element={<Layout />}>
            <Route path="companylist" element={<CompanyListPage />} />
            <Route path="poTrackingList" element={<PoTrackingList />} />
            <Route path="editPotInvPage" element={<EditPotInvPage />} />
          </Route>
        </Route>
        <Route path="/test" element={<TestPage />} />
        {/* catch all */}
        <Route path="*" element={<MissingPage />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
